import React, { useEffect, useState } from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import { AppActionCreators, SwapActionCreators, IApplicationState, IMoveTrackerListResponse, IDutyOfficerResponse } from '@nkr/store/index';
import { IMoveTracker, ILogistics, ILogisticsResponse, IDutyOfficer } from '@nkr/models/index';
import { DisplayType } from '@nkr/enums/display-type';
import { ControlLabel, FormGroup } from 'react-bootstrap';
import MaskedInput from 'react-maskedinput';
import styled from 'styled-components';
import MoveTrackerList from '@nkr/views/swap-management/swaps/move-tracker/move-tracker-list';
import LogisticsView from '@nkr/views/swap-management/swaps/swap-list/logistics/view';
import usePortalOpo from '@nkr/store/opo/hooks/use-portal-opo';
import { FilterCard, NoRows, opoCardStyles, opoTableStyles } from './opo-styles';

const TableCard = styled.div`
    ${opoCardStyles}

    & > .table {
        margin-bottom: 0;
        ${opoTableStyles}
    }

    & > .table > tbody > tr > td > .btn-danger.btn-xs {
        padding: 2px 8px;
        border-radius: 6px;
        font-weight: 600;
    }

    & > .table > tbody > tr > td:not([colspan]) > div:not(.btn-group) {
        height: 28px !important;
        padding: 0 4px;
        border-radius: 6px !important;
    }

    & > .table > tbody > tr > td:not([colspan]) > div:not(.btn-group) > .badge {
        height: 20px !important;
        padding: 0 8px;
        border-radius: 999px !important;
        font-size: 11px;
        font-weight: 600;
        line-height: 20px !important;
    }
`;

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getSwapsInProcess: (opoId: number) => Promise<IMoveTrackerListResponse>,
    getSwapsForMoveTracker: (opoId: number) => Promise<IMoveTrackerListResponse>,
    getLogisticsData: (donorId: number, recipientId: number) => Promise<ILogisticsResponse>,
    getCurrentDutyOfficer: () => Promise<IDutyOfficerResponse>
}

type TProps = IDispatchProps;

const OpoMoveTracker = (props: TProps) => {
    const { opoId } = usePortalOpo();
    const [list, setList] = useState([]);
    const [swapView, setSwapView] = useState('ALL');
    const [startDate, setStartDate] = useState(moment().day(0).format('MM/DD/YYYY'));
    const [endDate, setEndDate] = useState(moment().day(0).add(2, 'week').format('MM/DD/YYYY'));
    const [logistics, setLogistics] = useState<{ show: boolean, data: ILogistics | null }>({ show: false, data: null });

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        const endpoint = swapView == 'ALL' ? props.getSwapsForMoveTracker : props.getSwapsInProcess;

        props.showLoading('One moment please...').then(() => {
            endpoint(opoId)
                .then(response => {
                    setList(response.data.results);
                })
                .finally(() => {
                    props.hideLoading();
                });
        });
    };

    const handleViewLogistics = (item: IMoveTracker) => {
        props.showLoading('Fetching logistics information, one moment please...').then(() => {
            props.getLogisticsData(item.donorId, item.recipientId)
                .then(response => {
                    if (response.data.success) {
                        setLogistics({
                            show: true,
                            data: response.data.results
                        });
                    }
                })
                .finally(() => {
                    props.hideLoading();
                });
        });
    };

    const filteredAndSortedList = _.orderBy(list.filter((swap: IMoveTracker) => {
        console.log(swap.kidneyPickup)
        if (swapView == 'ALL') {
            let newStartDate = moment(startDate, 'MM/DD/YYYY', true);
            let newEndDate = moment(endDate, 'MM/DD/YYYY', true);
            let kidneyPickup = moment(swap.kidneyPickup, 'MM/DD/YY HH:mm', true);

            if (newStartDate.isValid() && newEndDate.isValid() && kidneyPickup.isValid()) {
                return kidneyPickup.isSameOrAfter(startDate, 'day') && kidneyPickup.isSameOrBefore(endDate, 'day');
            } else {
                return false;
            }
        } else {
            return new Date(swap.kidneyPickup) < new Date(new Date().toLocaleDateString() + ' 23:59:59');
        }
    }), (item: IMoveTracker) => {
        return new Date(item.kidneyPickup);
    }, ['asc']);

    console.log(swapView)

    return (
        <>
            <FilterCard>
                <div className='search-row'>
                    <FormGroup>
                        <ControlLabel>Swaps</ControlLabel>
                        <div className='search-toggles'>
                            <button type='button' className={swapView == 'ALL' ? 'btn active' : 'btn'} onClick={() => setSwapView('ALL')}>All</button>
                            <button type='button' className={swapView == 'TODAY' ? 'btn active' : 'btn'} onClick={() => setSwapView('TODAY')}>Today's</button>
                        </div>
                    </FormGroup>

                    {swapView == 'ALL' && (
                        <>
                            <FormGroup style={{ flex: '0 0 150px' }}>
                                <ControlLabel>Pickup Start Date</ControlLabel>
                                <MaskedInput
                                    className='form-control'
                                    mask='11/11/1111'
                                    name='startDate'
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.currentTarget.value)}
                                />
                            </FormGroup>

                            <FormGroup style={{ flex: '0 0 150px' }}>
                                <ControlLabel>Pickup End Date</ControlLabel>
                                <MaskedInput
                                    className='form-control'
                                    mask='11/11/1111'
                                    name='endDate'
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.currentTarget.value)}
                                />
                            </FormGroup>
                        </>
                    )}

                    <div className='search-stats'>
                        <div className='search-stat'>
                            <span className='k'>Scheduled Swaps</span>
                            <span className='v'>{filteredAndSortedList.length}</span>
                        </div>
                    </div>
                </div>
            </FilterCard>

            <TableCard>
                <MoveTrackerList
                    list={filteredAndSortedList}
                    displayType={DisplayType.All}
                    displayTimeZone={'YOUR'}
                    backgroundColor={'white'}
                    textColor={'#123'}
                    borderColor={'#486da8'}
                    headerBackgroundColor={'#eee'}
                    enableNotes={false}
                    isCourier={false}
                    noRowsMessage={<NoRows>There are no scheduled swaps{swapView == 'ALL' ? '' : ' for today'}</NoRows>}
                    onSwitchPlan={() => null}
                    onViewLogistics={handleViewLogistics}
                    onSaveNotes={() => null}
                    onAcknowledgeAlert={() => null}
                />
            </TableCard>

            <LogisticsView
                show={logistics.show}
                data={logistics.data}
                onClose={() => setLogistics({ show: false, data: null })}
            />
        </>
    );
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return ({
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getSwapsInProcess: (opoId) => {
            return dispatch(SwapActionCreators.getSwapsInProcessForOpo(opoId));
        },
        getSwapsForMoveTracker: (opoId) => {
            return dispatch(SwapActionCreators.getSwapsForMoveTrackerForOpo(opoId));
        },
        getLogisticsData: (donorId: number, recipientId: number) => {
            return dispatch(SwapActionCreators.getLogisticsDataByDonorRecipient(donorId, recipientId));
        },
        getCurrentDutyOfficer: () => {
            return dispatch(SwapActionCreators.getCurrentDutyOfficer());
        }
    });
}

export default connect<{}, IDispatchProps, {}>(
    null,
    mapDispatchToProps)(OpoMoveTracker);